import {ChangeDetectionStrategy, Component, Inject, Input, OnChanges, OnInit, SimpleChanges} from "@angular/core";
import {RouterService} from "../../services/router.service";

require('./oms-order-link.scss');
@Component({
  standalone: false,
  selector: 'app-oms-order-link',
  templateUrl: './oms-order-link.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OmsOrderLinkComponent implements OnInit, OnChanges {

  @Input() internalId: string;
  @Input() externalId: string;

  public displayId: string = undefined;
  public canCopy: boolean;
  public isDisplayExternalId: Boolean;
  public hasOmsOrderGetPermission: boolean;

  constructor(@Inject(RouterService) private routerService: RouterService, @Inject('splitService') private splitService) {
  }

  ngOnInit() {
    this.isDisplayExternalId = this.splitService.getSiteExternalIdConfig();
    this.displayId = !this.externalId ? this.internalId : (this.isDisplayExternalId ? this.externalId : this.internalId);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.internalId && !changes.internalId.isFirstChange()) {
      this.displayId = !this.externalId ? this.internalId : (this.isDisplayExternalId ? this.externalId : this.internalId);
    }
    if (changes.externalId && !changes.externalId.isFirstChange()) {
      this.displayId = !this.externalId ? this.internalId : (this.isDisplayExternalId ? this.externalId : this.internalId);
    }
  }

}
